/* eslint-disable default-param-last, no-unused-vars, spaced-comment */
import { filterableEventsTemplate, noResultsTemplate } from './template';
import { emPagination } from '../pagination';
import { getParams, setParams } from './params.js';
import * as helpers from '../helpers';

// Set domain to current domain and endpoint to post factory.
const { origin } = window.location;
const apiUrl = `${origin}/wp-json/em/v1/events-listing`;

/**
 * Pass parameters and fetch from post factory api.
 * @param  {Object}   element  the element to append/replace the html.
 * @param  {Object}   params   the query parameters to pass to the rest api.
 * @param  {Function} template the html markup.
 */
const getFilterableContent = (element, params = {}, template) => {
	(async () => {
		// Loop through the parameters and format for the query string.

		const esc = encodeURIComponent;
		let query = Object.keys(params).map((k) => `${esc(k)}=${esc(params[k])}`);
		query = query ? `?${query.join('&')}` : '';

		// Fetch the data.
		element.replaceChildren();	// Makes `element` empty, thus showing loading spinner
		const response = await fetch(apiUrl + query);
		let data = await response.json();
		data = data ? JSON.parse(data) : false;

		if (data.posts) {
			const block = document.getElementById(data.block_id);
			const resultCount = block.querySelector('.em-filterable-content__count span');

			// Set the result count.
			if (resultCount) {
				resultCount.innerHTML = data.found_posts.toLocaleString(document.getElementsByTagName('html')[0].getAttribute('lang'));
			}

			// Get the posts from the data.
			const { posts, not_found_message } = data; // eslint-disable-line
			let html = '';

			// Pass the post data to the template.
			posts.forEach((post) => {
				html += template(post);
			});

			// Output the pagination.
			html += emPagination(data.max_num_pages, data.current_page, 8, 'em-col pagination');

			// Append or replace the markup.
			element.innerHTML = html;

			// No Posts Found
			if (posts.length === 0) {
				element.innerHTML = noResultsTemplate(not_found_message);
			}

			// Process the pagination actions.
			const pageNumbers = block.querySelectorAll('.page-numbers');
			const contentContainer = block.querySelector('.em-filterable-content__listings');
			const inputs = block.querySelectorAll('.em-filterable-content__filters, .filter-search');
			const filterContainer = block.querySelector('.em-filterable-content__filter-container');

			// Loop through page numbers.
			pageNumbers.forEach((page) => {
				page.onclick = (e) => {
					page = e.target;
					const { parentNode } = page;
					if (parentNode) {
						page.parentNode.removeChild(page);
					}

					filterContainer.setAttribute('data-page', page.dataset.page);
					setParams(inputs, block.id, page.dataset.page);

					// Scroll back to top.
					helpers.scrollToEl(jQuery(block), 30);

					// Fetch the content.
					getFilterableContent(contentContainer, getParams(block.id, true, page.dataset.page), filterableEventsTemplate);
				};
			});
		}
	})();
};

export default getFilterableContent;
